import { APIClient } from "../helpers/api_helper";

// Early-access requests. The axios interceptor already unwraps `response.data`,
// so each call resolves to the JSON body directly.
const api = new APIClient();

// This member's own request, if any, plus the tiers they could ask for.
// Resolves to { request, tiers }.
export const getMyAccessRequest = () => api.get("/api/access-requests/mine");

// Ask for access, or update what was asked. { requestedTier, message }.
export const submitAccessRequest = (payload) =>
  api.create("/api/access-requests", payload);

// ── Admin ───────────────────────────────────────────────────────────────────

// The queue. Optional { status, limit }. Resolves to { requests, summary }.
export const listAccessRequests = (params) => api.get("/api/access-requests", params);

// Move one along: status is pending | contacted | granted | declined.
export const updateAccessRequest = (id, payload) =>
  api.update(`/api/access-requests/${id}`, payload);
